export class ApplicationErreur {
	code: string;
	message: string;
	messageAvecCode: string;
	countErreurs: number;
	erreurs: ApplicationErreur[];
}
